module.exports = __webpack_public_path__ + "img/gambar-erd (1).5348d8ab.png";